import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import DocumentActionButtonProps
	from '@components/CaseDetails/DocumentInformationDisplay/DocumentDetails/DocumentActions/DocumentActionButtonProps';
import { BaseButton } from '@components/BaseButton/BaseButton';

const useStyles = makeStyles((theme) => createStyles({
	button: {
		'color': theme.palette.primary.main,
		'& .MuiButton-label': {
			display: 'flex',
			gap: theme.spacing(1),
		}
	},
}));

const DocumentActionButton: React.FC<DocumentActionButtonProps> = ({ children, className, fieldName, ...props }) => {
	const classes = useStyles();
	return <BaseButton
		dataField={`document-${fieldName}Button`}
		variant="text"
		className={classNames(classes.button, className)}
		{...props}
	>
		{children}
	</BaseButton>;
};

export default DocumentActionButton;
